export { default } from "ember-inflector/helpers/singularize";
